import React from 'react';
import Chatbotui from '../../components/chatbotui/chatbotui';

const ChatPage = ({ userFeatures = {} }) => {
    return (
        <main>
            <Chatbotui userFeatures={userFeatures} />
        </main>
    );
};

export default ChatPage;
